import React from 'react';
import './GoogleSignInButton.css';

interface GoogleSignInButtonProps {
    label: string;
    href?: string;
    onClick?: () => void;
}

// Styled to Google's branding guidelines (https://developers.google.com/identity/branding-guidelines),
// which the design system has no current component for.
export const GoogleSignInButton = ({ label, href, onClick }: GoogleSignInButtonProps): React.JSX.Element => {
    const content = (
        <>
            <span className="vismaicon vismaicon-google" aria-hidden="true" />
            {label}
        </>
    );

    return href !== undefined ? (
        <a className="btn google-sign-in-button" href={href}>
            {content}
        </a>
    ) : (
        <button type="button" className="btn google-sign-in-button" onClick={onClick}>
            {content}
        </button>
    );
};

export default GoogleSignInButton;
